var map = {
	"./bar.png": "c969",
	"./cafe.png": "c745",
	"./localInfo.png": "ac7e",
	"./park.png": "37a4",
	"./restaurant.png": "ba00",
	"./roundArrow.png": "f1ec",
	"./tourist_attraction.png": "0b51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e5b";